import React, { useEffect, useState } from 'react';

import cx from 'classnames';

import Ball from '../../Icon/icons/Ball';
import Check from '../../Icon/icons/Check';
import s from './index.module.css';

function PasswordRequirementContent({ values }) {
  const requirements = [
    { id: 1, title: 'at least one lower case letter (a - z)', isValid: false, regExp: /[a-z]/g },
    { id: 2, title: 'at least one capital letter (A-Z)', isValid: false, regExp: /[A-Z]/g },
    { id: 3, title: 'at least one number (0-9)', isValid: false, regExp: /[0-9]/g },
    { id: 4, title: 'at least 8 characters', isValid: false, regExp: null },
    { id: 5, title: 'at least one special symbol (.!%$~^&-_*)', isValid: false, regExp: /[^a-zA-Z0-9]/g },
  ];
  const [state] = useState(requirements);

  useEffect(() => {
    state.forEach(() => {
      state[0].isValid = !!values?.match(state[0].regExp);
      state[1].isValid = !!values?.match(state[1].regExp);
      state[2].isValid = !!values?.match(state[2].regExp);
      state[3].isValid = values?.length >= 8;
      state[4].isValid = !!values?.match(state[4].regExp);
    });
  }, [values]);

  return (
    <div className={s.container}>
      <div className={s.header}>Your password must contain:</div>
      {state.map((el) => {
        return (
          <div className={cx(s.content, el.isValid && s.isValidContent)} key={el.id}>
            {el.isValid ? <Check /> : <Ball />}
            <span className={s.text}>{el.title}</span>
          </div>
        );
      })}
    </div>
  );
}

export default PasswordRequirementContent;
